import { AnnouncementsManagerTab } from '../../routes/announcementsManager/announcementsManagerPages';

import Announcements from './components/Announcements/Announcements';
import CommunityReports from './components/CommunityReports';
import CommentNotifications from './components/CommentNotifications';
import CommunitiesManager from './components/CommunitiesManager';

import {
  StyledNotificationIcon,
  StyledPostsIcon,
  StyledReportsIcon,
  StyledCommunityIcon,
} from './styles';
import texts from './texts.json';

const AnnouncementsManagerTabsConfig = {
  [AnnouncementsManagerTab.POSTS]: {
    label: texts.tabLabels[AnnouncementsManagerTab.POSTS],
    component: Announcements,
    icon: StyledPostsIcon,
  },
  [AnnouncementsManagerTab.COMMUNITIES]: {
    label: texts.tabLabels[AnnouncementsManagerTab.COMMUNITIES],
    component: CommunitiesManager,
    icon: StyledCommunityIcon,
  },
  [AnnouncementsManagerTab.NOTIFICATIONS]: {
    label: texts.tabLabels[AnnouncementsManagerTab.NOTIFICATIONS],
    component: CommentNotifications,
    icon: StyledNotificationIcon,
  },
  [AnnouncementsManagerTab.REPORTS]: {
    label: texts.tabLabels[AnnouncementsManagerTab.REPORTS],
    component: CommunityReports,
    icon: StyledReportsIcon,
  },
};

export {
  AnnouncementsManagerTabsConfig,
};
